import { createNadDebug } from '@ponpon/api-client'

export const CREATIVE_TEXT_MAX_LENGTH = 10_000
export const CREATIVE_TEXT_WARNING_LENGTH = 9_000

const descriptionLimitLog = createNadDebug('dw:description-limit:creative-text')

type DescriptionLimitLogValue = string | number | boolean | null | object | undefined

export function logCreativeTextLimitConfigured(
  surface: string,
  details: Record<string, DescriptionLimitLogValue> = {},
) {
  descriptionLimitLog({
    event: 'creative-text-limit-configured',
    trace_id: `description-limit:${surface}`,
    surface,
    maxLength: CREATIVE_TEXT_MAX_LENGTH,
    warningLength: CREATIVE_TEXT_WARNING_LENGTH,
    ...details,
  })
  descriptionLimitLog(
    `creative-text-limit-configured surface=${surface} maxLength=${CREATIVE_TEXT_MAX_LENGTH} warningLength=${CREATIVE_TEXT_WARNING_LENGTH}`,
  )
}
